import { useId } from "react";

type Props = {
  label: string;
  description: string;
  children: React.ReactNode;
};

export function TravellerTypeSelectionItem({
  label,
  description,
  children,
}: Props) {
  const labelId = useId();

  return (
    <div className="flex justify-between" aria-labelledby={labelId}>
      <div className="flex flex-col">
        <h4 className="mb-1 font-medium text-text-primary" id={labelId}>
          {label}
        </h4>

        <span className="inline-block max-w-50 text-xs font-normal text-wrap text-text-tertiary">
          {description}
        </span>
      </div>

      {children}
    </div>
  );
}
